module.exports={
    felton_quantitative_title: 'UPlus quantitative trading robot',
    felton_quantitative_content1: 'Based on big data and Virtual Currency Trading Robot',
    felton_quantitative_content2: 'Built by artificial intelligence,Let you lie down and make money',
    start_robot: 'Start the Robot',
    product_description: 'Product Description',
    smart_contract_transactions: 'Smart contract transactions',
    smart_contract_transactions_tip: 'Long-short hedging arbitrage, risk manageable',
    per_year:'year',
    fully_automated_spot_trading: 'Fully automated spot trading',
    fully_automated_spot_trading_tip: 'Dual-Currency Arbitrage for Accumulating Coins in Sideways Markets',
    spot_grid_trading: 'Spot grid trading',
    spot_martin_trading: 'Spot Martin trading',
    spot_martin_trading_tip: 'Doubling down on one side lowers costs, and taking profits on pullbacks',
    golden_triangle: 'Golden Triangle\nArbitrage',
    stable_income: 'Stable Income',
    introduce: 'INTRODUCE',
    golden_triangle_tip: 'Three currencies form a closed loop, circular cross trading',
    stability: 'Stability',
    rate_return: 'Rate of Return',
    capture_big_market: 'Capture the Big Market',

    bb_transaction: 'BB\nTransaction',
    long_term_profit: 'Long-term profit',
    bb_transaction_tip: 'Buy and sell between different currencies to earn the difference',

    ub_transaction: 'UB\nTransaction',
    high_return: 'High return',
    ub_transaction_tip: 'Trade USDT with different currencies to earn USDT',

    grid_strategy: 'Grid\nstrategy',
    volatility_arbitrage: 'Volatility arbitrage',
    grid_strategy_tip: 'Stable Arbitrage via Automated Low-Buy/High-Sell in Volatile Markets',

    martin_strategy: 'Martin\nstrategy',
    money_management: 'Money management',
    martin_strategy_tip: 'Double the bet on one side to lower the cost and pull back the profit',

    contract_strategy: 'hedging contract transaction',
    stay_tuned_for: 'high yield',
    coming_soon: 'Long/short contract hedging losses, swing arbitrage, superb returns',

    investment_advice: 'Product advantages',
    reference_plan: 'Reference Plan',
    product_portfolio : 'Product Portfolio',
    membership_level: 'Membership Level',
    for_people: 'For People',
    features: 'Features',
    monthly_return: 'Monthly return',
    turn_on: 'Turn on',
    option_one: 'Option One',
    option_one_introduce: '2“Golden Triangle Arbitrage”\n + \n2“BB Transaction”',
    option_one_for_people: 'Bitcoin believers who hoard coins',
    option_one_features: 'Multi-currency transactions, large number of orders, multiple currencies',
    option_two: 'Option Two',
    option_two_introduce: '1“Golden Triangle Arbitrage”\n+\n5“BB Transaction”',
    option_two_for_people: 'Bitcoin believers who hoard coins',
    option_two_features: 'Suitable for earning profits in flat trading, not suitable for violent market fluctuations',
    option_three: 'Option Three',
    option_three_introduce: '2“UB Transaction”\n+\n1“BB Transaction”',
    option_three_for_people: 'Obtain long-term financial management income',
    option_three_features: 'Suitable for earning income when the market fluctuates sharply, there may be 30%-50% floating loss in the short term',
    no_suitable_solution: 'There is no suitable solution, try a ',
    custom_solution: 'custom solution?',

    product_advantages: 'Product Advantages',
    exclusive_strategy_model: 'Exclusive Strategy Model',
    exclusive_strategy_model_tip: 'Intelligent trading algorithm and refined position management, robust risk control system and flexible point capture',
    fully_automatic_unattended: 'Fully Automatic Unattended',
    fully_automatic_unattended_tip: 'Fool-style proxy investment, reduce time cost, make up for information asymmetry, and easily enjoy the income after bedtime',
    financial_security: 'Financial Security',
    financial_security_tip: 'Support API to access Binance and other major exchanges, digital assets are not transferable and always in their own account',
    regularly_update_policy: 'Regularly Update the Policy',
    regularly_update_policy_tip: 'A strong technical strategy team, according to market changes, regularly update the latest policy',

    opening_process: 'Opening Process',
    choose_exchange_connect: 'Choose an exchange and connect',
    recharge_fuel: 'recharge fuel',
    quantification_robot:'Fully Automated Quant Robot',
    download_now:'Download',
    trading_robot:'Smart Contract Trading | Fully Automated Quantitative Trading Robot',
    quantitative_robot:'Quantitative trading robot',
    monthly_income:'Monthly income is as high as',
    cryptocurrency:'Trusted by millions of cryptocurrency investors',
    add_official:'Add official Telegram',
    subscribe:'official channel',
    download_app:'Download',
    ios_download:'iOS download',
    android_download:'Android download',
    more_download:'More ways to download',
    view_more:'View more',
    start_robot:'Start the robot',
    view_network_revenue:'Total Network Revenue',
    register_now:'Register now and enjoy permanent free quantitative tools',
    registernow:'Register now',
    incognito_browsing:'You have enabled "Incognito Browsing" mode, which will affect your normal use. Please switch to normal browsing mode first!',
    warn:'warn',
    sure:'Sure',
    free_trading_bots:'4 free trading bots',
    cryptocurrency_is:'Cryptocurrency is ushering in a new era',
    u_plus_helps:'U plus helps you create, grow, and preserve your wealth',
    top_performance:'Top-tier performance, ultra-fast trading',
    exchange_technology_driven:'Tech-driven exchange with ultra-low latency and instant matching',
    asset_protection:'Asset protection, ultimate security',
    asset_protection_tip:'U Plus meets CCSS standards for asset and data security',
    high_liquidity:'High liquidity, low spread',
    high_liquidity_tip:'U Plus leveraged trading: ultra-efficient, minimal slippage',
    service_24_7:'24/7 service',
    service_24_7_tip:'Ensure system operation and provide 24/7 customer service',
    convenient_and_ease:'Convenient and easy to use',
    convenient_and_ease_tip:'Offers multiple order systems and trading tools, with manageable risks',
    trade_with_peace_of_mind:'Trade with peace of mind anytime, anywhere',
    platform_offers:'U Plus available on web, Android, and iOS',
    cryptocurrency_is_era:'Cryptocurrency is ushering in a new era',
    start_your:'Start your digital currency journey in 60 seconds',
    select_exchange_connect:'Select an exchange and connect',
    top_up_fuel:'Top up fuel',
    users_all_over_the_world:'Users all over the world',
    more_than_100_countries:'More than 100 countries and regions',
    total_earnings_network:'Network-wide earnings',
    total_return_entire_network:'Total Return on the Entire Network',
    has_been_operating_stably:'Has been operating stably',
    day:'day',
    hours:'hours',
    robot_stability:'Robot stability',
    make_wealth_within_reach:'Make wealth within reach',
    everything_you_need:'Everything you need is now in the UPlus application',
    ios_profile_download:'iOS profile download',
    android_download:'Android download',
    more_download:'More ways to download',
    our_partners:'Our partners',
    sure:'Sure',
    app_name:'UPLUS Smart Trading App',
    app_description:'A brand-new futures and spot strategy to make money every day',
    app_description_tip:'Come and experience it!',
    app_description_tip_note:'Note: Apple phone users need to use a VPN to access this app!',
    purchase_successful:'Purchase successful, you have been upgraded to',
    go_set_up_the_robot:'Go set up the robot',
    your:'your',
    order_has_not_yet_been_paid:'order has not yet been paid.',
    to_complete:'to complete',
    see_you_next_time:'See you next time',
    major_upgrade:'Major upgrade!',
    all_contract_users:'All contract users fuel fees/points',
    discount:'30% off',
    exemptions_are_being_offered:'Exemptions are being offered...',
    live_broadcast:'UPLUS live broadcast',
    closed:'Closed',
    incentive_program:'Incentive program',
    level:'level',
    upgrade_conditions:'Upgrade conditions',
    award:'Award',
    things_to_note:'Things to note:',
    regular_users_enter:'Regular users enter the rewards system after upgrading to Lv0. Direct referrals in the rules refer to users at Lv0 or higher.',
    protection_period:'Levels Lv2, Lv3, and Lv4 each have a one-month protection period, while levels Lv5 and Lv6 each have a three-month protection period.',
    brokerage_incentive_program:'Brokerage Incentive Program',
    omni_channel_rewards:'Omni-channel rewards',
    level_4_and_above:'Level 4 and above can apply to become a broker. Please contact customer service for details.',
    fuel_consumption_30_day:'30-day fuel consumption ≥ 30 USDT',
    direct_pushes:'direct pushes',
    deduction_501_2000U:'30-day deduction of 501-2000U',
    deduction_2001_10000U:'30-day deduction of 2001-10000U',
    off_chain_201_500_people:'Off-chain 201-500 people, 30-day fee of 10,001-30,000 USDT',
    blockchain_501_1000_people:'For 501-1000 people on the blockchain, the fee will be deducted from 30,001-100,000 USDT over 30 days',
    more_than_1001_people:'More than 1001 people on the blockchain, with over 100,000 USDT deducted in 30 days',
    home:'Home page',
    user:'User Center',
    robotics:'Robotics Center',
    return_home:'Return-to-home center',
    security_center:'Security Center',
    browser_not:'Your browser does not support local storage',
    enter_maximum:'You can only enter a maximum of 500 characters',
    question_type:'Please select question type',
    enter_description:'Please enter a description of the problem',
    sensitive_words:'This contains sensitive words. Please edit it again!',
    images_must:'Images must be in JPG or PNG format!',
    image_size:'Image size cannot exceed 12MB!',
    received_thank:'Received, thank you very much for your valuable feedback',
    view_tutorial:'View tutorial'
   
    
}